module.exports = __webpack_public_path__ + "img/camera.4711aaf3.png";